//jsxhook

import {
  Label2,
  PrimaryButton,
  SmallArrowLeft
} from "@sixty-six-north/ui-system"
import { useTranslation } from "react-i18next"
import { useCheckoutConfig } from "../../layout/CheckoutConfigHooks"
import React, { ReactNode } from "react"
import { Box, Flex } from "theme-ui"
import Link from "../../components/Link"

export const CheckoutButton: React.FC<{
  submit: () => Promise<unknown>
}> = ({ submit }) => {
  const { t } = useTranslation("checkout")
  const { disabled } = useCheckoutConfig()
  if (disabled) return null
  return (
    <Box>
      <PrimaryButton fill id="checkoutButton" onClick={() => submit()}>
        {t("checkout", { defaultValue: "Checkout" })}
      </PrimaryButton>
    </Box>
  )
}
export const CheckoutButtonsContainer: React.FC<{ children?: ReactNode }> = ({
  children
}) => {
  return (
    <Flex
      sx={{
        mt: 32,
        alignItems: "center",
        marginBottom: 24,
        flexDirection: ["column-reverse", "column-reverse", "row"],
        flexWrap: "wrap-reverse"
      }}
    >
      {children}
    </Flex>
  )
}

export const NextButtonContainer: React.FC<{ children?: ReactNode }> = ({
  children
}) => {
  return (
    <Box
      sx={{
        width: ["100%", null, null, "auto"],
        flexShrink: 0,
        flexGrow: 1
      }}
    >
      {children}
    </Box>
  )
}

export const PreviousButtonContainer: React.FC<{
  link: { href: string; as?: string }
  children?: ReactNode
}> = ({ link, children }) => {
  return (
    <Flex
      sx={{
        width: ["100%", null, null, "auto"],
        flexShrink: 1,
        flexGrow: 1
      }}
    >
      <Label2
        sx={{
          a: {
            color: "grey.1",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            py: 16,
            pr: 16
          }
        }}
      >
        <Link
          {...link}
          sx={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center"
          }}
        >
          <SmallArrowLeft sx={{ mx: 8 }} />
          {children}
        </Link>
      </Label2>
    </Flex>
  )
}
